<mat-form-field [class]="inputClass">

  <mat-label class="with-action">
    <div class="align-h-space-between">
      <span>
        {{ label }}
        @if (tooltip) {
          <i class="icon icon-info ic-primary ml-5" [matTooltip]="tooltip"></i>
        }
      </span>

      @if (canAdd) {
        <button
          appStopPropagation
          type="button"
          class="btn icon icon-plus link"
          (click)="openAddItemDialog()">
          Add Business
        </button>
      }
    </div>
  </mat-label>

  <mat-select [multiple]="multiple"
              [disabled]="disabled"
              [errorStateMatcher]="errorStateMatcher"
              [placeholder]="placeholder"
              [compareWith]="compareFn"
              [(ngModel)]="value"
              (selectionChange)="onSelect($event.value)"
              (blur)="onTouched()">

    @if (options) {
      <!-- Toggle all checkbox -->
      @if (multiple) {
        <mat-checkbox
          [checked]="value?.length === options.length"
          [indeterminate]="isIndeterminate"
          class="checkbox-select-all"
          (change)="toggleAll($event.checked)">
          Select All
        </mat-checkbox>
      }
      <!-- Group mode -->
      @if (groupBy) {
        @if (hasEmptyOption) {
          <mat-option [value]="false">{{ emptyOptionLabel }}</mat-option>
        }
        @for (groupName of groupedOptions.keys; track groupName) {
          <mat-optgroup [label]="groupName">
            @for (business of groupedOptions.get(groupName); track business) {
              <mat-option [value]="business">
                {{ business.name }}
              </mat-option>
            }
          </mat-optgroup>
        }
      }
      <!-- List mode -->
      @if (!groupBy) {
        @if (hasEmptyOption) {
          <mat-option [value]="false">{{ emptyOptionLabel }}</mat-option>
        }
        @for (business of options; track business) {
          <mat-option [value]="business">
            {{ business.name }}
          </mat-option>
        }
      }
      <!-- Empty list -->
      @if (!options.length) {
        <mat-option [value]="false" [disabled]="true">
          {{ emptyMessage }}
        </mat-option>
      }
    }

  </mat-select>

  <div matSuffix>
    @if (isLoading) {
      <app-preloader [type]="preloaderTypes.ICON" [size]="20"></app-preloader>
    }
  </div>

  <!-- Show control errors -->
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
